import CategoryTag from './CategoryTag';

export default CategoryTag;